module.exports =  {
  TITLE: {
   default: 'Buscar Hotel|Miles de hoteles en Asia disponibles para reservar en línea',
detail: '|Reserva de Hotel',
},
hotel: {
// 酒店搜索改版新增翻译--英文
ROOMS: 'Habitaciones',
GUESTS: 'Invitados',
CHECK_IN_NUM: 'Invitados',
PREFIX_ADULTS: '',
SUFFIX_ADULT: 'Adulto',
SUFFIX_ADULTS: 'Adultos',
PREFIX_CHILDREN: '',
SUFFIX_CHILD: 'Niño',
SUFFIX_CHILDREN: 'Niños',
CHILD_AGE: 'Edad del Niño',
NO_MATCH_TIPS: 'El tipo de habitación a continuación no coincide con el número de habitaciones e invitados que seleccionó.',

Book_Hotel: 'Reservar Hotel',
Select_your_destination: 'Selecciona tu destino',
Please_enter_your_destination: 'Por favor, ingresa tu destino/hotel',
Booked_up: 'Agotado',
Hotel_description: 'Descripción del Hotel',
Check_in_date: 'Fecha de entrada',
Check_out_date: 'Fecha de salida',
Sold_out: 'Agotado',
Non_refundable: 'No reembolsable',
reserve: 'Reservar',
Pay_Online: 'Pagar en línea',
Only_rooms_left_before: 'Solo ',
Only_rooms_left_after: ' habitación(es) disponible(s)',
Cancellation_Policy: 'Política de Cancelación',
See_all_prices_before: 'Ver todos los ',
See_all_prices_after: 'precios',
Estimated_time_of_arrival: 'Hora estimada de llegada',
make_your_schedule_well_planned: 'La hora es para la zona horaria local, por favor planifica bien tu horario y llega a tiempo.',
Hotel_Not_Found: 'Hotel No Encontrado',
Please_change_your_search: 'Por favor cambia tu búsqueda',
Submit_an_application: 'Enviar una solicitud',
Hotel_Confirmation: 'Confirmación del Hotel',
Many_Night_Stay_before: '',
Many_Night_Stay_after: '-Noches de Estancia',
Hotel_Booking_Number: 'Número de Reserva de Hotel',
Online_Payment: 'Pago en Línea',
The_guest_Room_before: 'El huésped[Habitación',
The_guest_Room_after: ']',
Contact_number: 'Número de contacto',
Bring_all_valid_IDs: 'Por favor, lleva todas las identificaciones válidas de todos los huéspedes al hacer el check-in.',
Hotels_Found_before: '',
Hotels_Found_after: 'Hoteles Encontrados',
Hotels_Presented_before: '',
Hotels_Presented_center: 'Hoteles Presentados (',
Hotels_Presented_after: ' en total)',
Please_change_the_dates: 'Habitación no disponible en tus fechas, por favor cambia las fechas.',
Login: 'Inicia sesión en la APP para reservar un hotel',
Nights_in_total_before: '',
Nights_in_total_after: 'Noches en total',
Location: 'Ubicación',
Pictures: 'Imágenes',
Description: 'Descripción',
Policy: 'Política',
Check_in_and_check_out_time: 'Hora de Check-in y Check-out',
Check_in_and_Check_out_before: 'Check-in: después de ',
Check_in_and_Check_out_center: 'Check-out: antes de ',
Check_in_and_Check_out_after: '',
Check_in_time: 'Hora de Check-in',
Check_out_time: 'Hora de Check-out',
Hotel_Information: 'Información básica',
Opening_Date: 'Fecha de apertura',
Renovation_Date: 'Fecha de renovación',
Facility_Service: 'Instalaciones y Servicios',
Payment_methods: 'Métodos de pago aceptados por el hotel',
Hotel_Address: 'Dirección del Hotel',
Pay_online: 'Pagar en línea',
Pay_offline: 'Pagar fuera de línea',
Night_stay_before: '',
Night_stay_after: '-Noche(s) de Estancia,',
Rooms_total_before: 'Habitaciones',
Rooms_total_after: 'en total',
Guest_name_must_be_provided: 'Se debe proporcionar el nombre completo del huésped.',
Please_fill_in_your_contact_number: 'Por favor, completa tu número de contacto',
Select_estimated_time_of_arrival: 'Selecciona la hora estimada de llegada',
Number_of_Rooms: 'Número de Habitaciones',
Maximum_guests_per_room_before: 'Máximo ',
Maximum_guests_per_room_after: ' huéspedes por habitación',
Many_Rooms: ' Habitaciones',
Service_Fee_Included: '(Incluye impuestos y tarifas de servicio)',
Last_Name: 'Apellido',
First_Name: 'Nombre ',
Room: 'Habitación',
Additional_Tax: 'Impuesto Adicional',
Please_inform_the_hotel: 'Si planeas llegar más allá de la hora estimada de llegada, por favor informa al hotel con anticipación.',
Please_inform_the_hotel_first: 'Llegar al hotel más allá de la hora estimada de llegada sin contactar al hotel con anticipación afectará la disponibilidad de la habitación y la cena. Por favor, informa primero al hotel para confirmar la disponibilidad en tal circunstancia.',
Booking_Cancellation: 'Cancelación de Reserva',
Reason_of_Cancellation: 'Motivo de Cancelación',
Incorrect_Information_Filled: 'Información Incorrecta Completada',
Itinerary_Changed: 'Itinerario Cambiado',
Lower_price_on_other_APP: 'Precio más bajo en otra APP',
Low_quality_hotel: 'Hotel de baja calidad',
Book_at_a_lower_price: 'Reserva a un precio más bajo en la recepción',
Other: 'Otro',
Please_write_your_reason: 'Por favor, escribe tu motivo',
After_cancellation_done: 'Después de la cancelación, el pago se devolverá al pagador original en un plazo de 3 días laborables.',
How_to_fill_in_the_guest_name: 'Cómo completar el nombre del huésped',
It_should_be_exactly_the_same: 'Proporciona el nombre del huésped en letras inglesas para la reserva del hotel. Debe ser exactamente igual que el certificado presentado al hacer el check-in.',
How_to_fill_in_a_Chinese_name: 'Cómo completar un nombre chino:',
How_to_fill_in_a_English_name: 'Cómo completar un nombre inglés',
For_example: 'Por ejemplo: Si tu nombre chino es "韩梅梅", el apellido es "Han", el primer nombre es "Meimei".',
No_specical_characters: 'No ingreses números ni caracteres especiales.',
Name_rule_first: 'El apellido va primero, seguido del primer nombre, y si hay un segundo nombre, va seguido de un espacio detrás de los dos nombres.',
Name_rule_second: 'Por ejemplo: Green / Jim Stephanie',
Details: 'Detalles',
Pay_now: 'Pagar ahora',
Hotel: 'Hotel',
Check_in: 'Check in',
Car: 'Auto',
All_bookings: 'Todas las reservas',
All: 'Todo',
PROMPT: 'Atención',
NETWORK_TIMEOUT: 'Tiempo de espera de red agotado, vuelva a enviar el pedido',
ORDER_SUBMIT_SLOW: 'Submitting your order, please wait… (supplier confirmation may take a while, do not close the page or submit again)',
ORDER_SUBMIT_UNKNOWN: 'Order result unknown. Please check "My Orders" before trying again — do not place the same order twice',
REQUEST_FAIL: 'La solicitud falló, inténtelo de nuevo más tarde',


 Search: 'Buscar',
COST_DESCRIPTION: 'Detalle de Precio',
TOTAL: 'Total',
SEE_ORDER_INFO_TO: 'Pagar',
KONW: 'Entendido',
BOOKING_INFORMATION: 'Información Importante',
Book_Now: 'Pagar Ahora',
MAP: 'Mapa',
CONTACT_INFORMATION: 'Información de Contacto',
LOADING: 'Cargando...',
SORT_FILTER: 'Ordenar/Filtrar',
SCREENING: 'Filtrar',
SEQUENCE: 'Ordenar',
PHONE_ASK: 'Llámanos',
ABOVE: '',
SUBMINT_ORDER: 'Enviar',
OK: 'OK',
Order_detail: 'Detalles de la Orden',
BOOKING_INFO: 'Información de Reserva',
PAYMENT_AMOUNT: 'Monto del Pago',
Order_time: 'Hora de Reserva',
ORDER_NUMBERS: 'Número de Reserva',
PAY_TYPE: 'Método de Pago',
BALANCE: 'Saldo',
CURRENT_BALANCE_BEGIN: 'Saldo',
OVERPLUS_BALANCE_BEGIN: 'Restante',
OTHER_PAYMENT: 'Otros métodos de pago',
Unionpay: 'UnionPay',
Wechatpay: 'Pago con WeChat',
Alipay: 'Alipay',
AGREE_SERVICE_AGREEMENT_BEFORE: 'Hacer clic en "Pagar Ahora" significa que aceptas los ',
AGREE_SERVICE_AGREEMENT_AFTER: '',
SERVICE_AGREEMENT: '《Términos del Servicio》',
PAYMENT_ORDER: 'Pago de Reserva',
Total_pay: 'Monto a Pagar',
PAY_SUCCESS: 'Pago Aceptado',
CHECK_THE_ORDER: 'Verificar la Orden',
BACK_TO_INDEX: 'Volver al Inicio',
CANCEL: 'Cancelar',
RECOMMED: 'Recomendar',
PRICE: 'Precio',
HIGH: 'Alto',
LOW: 'Bajo',
RESET: 'Restablecer',
SELECT_TIME: 'Seleccionar Fecha',
Hotel_guest: 'El huésped',
Select: 'Por favor, selecciona',
Emial_address: 'Por favor, ingresa la dirección de correo electrónico',
Booking_explan: 'Información de Reserva',
VIEW_MORE: 'Ver más',
COLLAPSE: 'Ocultar',
Week: '',
Month: '',
TOURISM_CHECK_IN_HOTEL: 'Check-in',
TOURISM_LEAVE_HOTEL: 'Check-out',
arrive: 'Destino',
Room_description: 'Descripción de la Habitación',
Meals: 'Comidas',
Room_Type: 'Tipo de Habitación',
BOOKING_EXPLANATION: 'Información de Reserva',
BOOKING_BUTTON: 'Reservar',
REMIND_SUBMIT_ORDER: 'Continuar',
login_now: 'Las reservas de hotel requieren inicio de sesión, ¿iniciar sesión ahora?',
the_real_scene: 'Las imágenes son solo de referencia y están sujetas a la escena real.',
Bed: 'Cama',
Rooms: 'Habitaciones',
Room_rate: 'Tarifa de la Habitación',
notified_by_SMS: 'Después de que la reserva sea exitosa, se te notificará por SMS',
email_notifications: 'Usado para recibir notificaciones por correo electrónico',
Booking_deadline: 'Fecha límite de Reserva',
Child: 'Niño',
Additional_notes_about_payment: 'Notas adicionales sobre el pago',
Nights: 'Noches',
Minimum_nights_before: 'Mínimo',
Minimum_nights_after: 'noches',
Size: 'Tamaño',
Guests: 'Invitados',
Room_rate_1: 'Tarifa de la Habitación',
Tax_service_fee: 'Impuestos/tarifa de servicio',
Pay_now_1: 'Pagar ahora',
Filter: 'Filtrar',
Room_rate2: 'Tarifa de la Habitación',
Show_on_map: 'Mostrar en el mapa',
Detail: 'Detalle',
Room_Detail: 'Detalle de la Habitación',

TAXES_INCL: 'Impuestos incluidos',
SEARCH_EMPTY_TIP: 'Lo siento, no hay disponibilidad en la fecha seleccionada, puedes: buscar fechas alternativas o hoteles',
severalNight: 'Noches',
immediateBooking: 'Reservar Ahora',
Refundable: 'Reembolsable',
MORE: 'Más',
adultsCompany: 'adultos',
ServiceTerms: 'Servicios y Términos',
roomPlan: 'Plan',
guestRoom: 'Habitación',
searchAgain: 'Buscar de nuevo',
roomNight: 'habitación/noche',

NAME_TXT: 'Nombre',
HOLDER_NAME: 'Nombre del Titular de la Tarjeta',
EXPIRATION_DATE: 'Fecha de Vencimiento',
FORMAT_TXT: 'Formato',
SECURITY_CODE: 'Código de Seguridad',
MASTER_CARD_NAME: 'Master Card',
JCB_CARD_NAME: 'JCB',
DIGITS_ON_BACK_OF_CARD: 'Los 3 dígitos en la parte posterior de la tarjeta.',
AMERICAN_EXPRESS_NAME: 'American Express',
FOUR_CAR_NUM_TIPS: '4 dígitos en la parte frontal de la tarjeta',
ENTER_COMPLETE_CARD_NUM: 'Por favor, ingresa el número completo de la tarjeta.',
PLEASE_ENTER_HOLDER_NAME: 'Ingresa el nombre del titular de la tarjeta',
ENTER_SECURITY_CODE: 'Ingresa el código de seguridad',
ENTER_EXPIRATION_DATE: 'Ingresa la fecha de vencimiento',
ROOM_DETAILS: 'Detalles de la Habitación',
CONDITION_CANCEL: 'Reembolsable',
CHOOSE_PAYMENT_METHOD: 'Pago',
ORDER_TOTAL_LUMP: 'Monto Total',
CREDIT_CARD_NUM: 'Número de Tarjeta de Débito/Crédito',
MAINLAND_CARD_ONLY: 'Solo tarjeta bancaria emitida fuera de la China continental.',
SHUT_DOWN: 'Cerrar',
PROVIDER_FROM_CHINA_BANK: 'Servicio de pago proporcionado por B.O.C',

COUPON: 'Cupón',
APPLY_A_COUPON: 'Aplicar un Cupón',
NO_USE: 'No aplicable a esta oferta.',
Discard: 'Descartar',
REDEEM: 'Canjear',
EMPTY_COUPON: 'Por favor, ingresa el código de promoción',
NOTICE_COUPON: 'Solo se puede canjear un cupón por cada reserva; el cupón se canjeará después de enviar la reserva.',


  
  // ... 其他代码
  BREAKFAST_INCLUDE: 'desayuno incluido',
  BREAKFAST_EXCLUDE: 'desayuno no incluido',
  DOUBLE_BED: 'cama doble',
  TWIN_BED: 'cama gemela',
  FREE_CANCEL: 'cancelación gratuita',
  MEALS: 'comidas',
  EVALUATION: 'Reseña',
  FEATURED_REVIEWS: 'Reseñas destacadas',
  ALL_REVIEWS: 'Todas las Reseñas',
  OVERALL_EVALUATION: 'Reseña General',
  ANONYMOUS: 'Anónimo',
  EVAL_GENERAL_LIST_1: 'Pobre',
  EVAL_GENERAL_LIST_2: 'Regular',
  EVAL_GENERAL_LIST_3: 'Promedio',
  EVAL_GENERAL_LIST_4: 'Bueno',
  EVAL_GENERAL_LIST_5: 'Excelente',
  MAX_IMAGES_WITH_NINE: 'Se pueden seleccionar un máximo de 9 imágenes.',
  GRADE_EVAL: 'Seleccione la Calificación General',
  DISTANCE_FILTER: 'filtrar por distancia',
  EDIT_EVALUATION: 'dar comentarios',
  GO_TO_EVAL: 'dar comentarios',
  EVAL_POINTS_AWARD: 'Buenos comentarios pueden ganar 1000 puntos, 1000 puntos = 10RMB',
  NEARBY_LIKE_HOTEL: 'hotel similar cercano',
  DISTANCE_HOTEL: 'al hotel',
  PLEASE_ENTER_COMMENT: 'comentarios',
  AWARD_POINTS_TIPS: 'Los mejores comentarios pueden obtener 1000 puntos, 1000 = 10RMB',
  NO_SHOW_ANONYMOUS_AVATAR: 'Los comentarios anónimos no mostrarán su logotipo y nombre',
  LOCATION: 'ubicación',
  FACILITY: 'instalación',
  SERVICE: 'servicio',
  HEALTH: 'limpio',
  LANGUAGE_SELECT: 'idioma',
  LIMIT_COMMENT_TXT: 'La reseña debe tener entre 5 y 2000 caracteres',
  SHARE_MEDIA: 'Compartir fotos y videos',
  SETTLEMENT_FEEL: 'Comentarios',
  SUBMIT_EVAL: 'Confirmar',
  HOTEL_STR: 'Detalles',
  EVAL_NUM_AFTER: 'reseña',
},
header: {
  SKIING: 'Estación de esquí',
  header_internal_call: 'China continental:',
  header_abroad_call: 'Internacional:',
  header_app_download: 'Aplicación Móvil',
  service_telephone: 'Servicio al Cliente',
  account_number: 'Cuenta',
  if_bg_user: '¿No eres miembro de BaiGolf?',
  home: 'Inicio',
  hotel: 'Hotel',
  Golf: 'Golf',
  PLAY_STAY: 'Jugar y Hospedarse',
  RENT_CAR_HOME: 'Automóvil',
  center_user: 'Centro de Miembros',
  header_my_order: 'Mis Reservas',
  header_notmember_order: 'Reservas de Invitados',
  header_edit_password: 'Cambiar Contraseña',
  header_logout: 'Cerrar Sesión',
  header_login: 'Iniciar Sesión',
  header_register: 'Registrar',
  header_point: 'Mis Puntos',
  header_all_language: 'Todos los Idiomas',
  down_load_app: 'Escanear el Código QR para Descargar',
  login_discount_tip: 'Inicia sesión para ganar bonificaciones y disfrutar de tus beneficios exclusivos',
  currency_balance_limit: 'La moneda actual aún tiene saldo, no se puede cambiar de moneda'
},
footer: {
  footer_partner: 'Socios',
  footer_about_us: 'Sobre Nosotros',
  footer_about_baigolf: 'Acerca de BaiGolf.com',
  footer_privacy_policy: 'Política de Privacidad de BaiGolf.com',
  footer_use_of_terms: 'Términos del Servicio de BaiGolf.com',
  footer_contact_us: 'Contáctanos',
  footer_sitemap: 'Mapa del Sitio',
  footer_use_of_question: 'Preguntas Frecuentes',
  footer_ios_system: 'iOS',
  footer_android_system: 'Android',
  footer_app_load: 'Descarga de la Aplicación',
  footer_sina_weibo: 'Sina Weibo',
  footer_tencent_weibo: 'Microblog de Tencent',
  footer_share_to: 'Compartir',
  copyright1: 'Guangzhou BaiGolf Information Technology Co., Ltd. Derechos de Autor ',
  copyright2: 'Yue ICP Registro No.14070002',
  news_center: 'Centro de Noticias',
  about_baigolf: 'Acerca de BaiGolf',
  help: 'Ayuda',
  management_system: 'Sistema de Gestión de Golf BG (BGMS)',
  wechat_official_account: 'Cuenta Oficial de WeChat',
  download_baiGolf_app: 'Descargar la Aplicación BaiGolf',
  privacy_policy: 'Política de Privacidad',
  use_of_terms: 'Términos del Servicio',
  footer_integral: 'Política de Puntos',
  footer_reserve: 'Política de Reservas',
  footer_abroad_call: 'Internacional',
  footer_internal_call: 'China continental'

  }
}



// WEBPACK FOOTER //
// ./src/lang/spain.js